__turbopack_context__.v({
  "Break": "SearchPagination-module-scss-module__ME5gPa__Break",
  "Disabled": "SearchPagination-module-scss-module__ME5gPa__Disabled",
  "Page": "SearchPagination-module-scss-module__ME5gPa__Page",
  "PageNext": "SearchPagination-module-scss-module__ME5gPa__PageNext",
  "PagePrevious": "SearchPagination-module-scss-module__ME5gPa__PagePrevious",
  "Pagination": "SearchPagination-module-scss-module__ME5gPa__Pagination",
  "PaginationWrapper": "SearchPagination-module-scss-module__ME5gPa__PaginationWrapper",
});
